"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamPage = exports.Team = void 0;
/**
 * Teams working on and with the myCampus 2.0 platform.
 */
var Team;
(function (Team) {
    Team["WEB_CORE"] = "Team Web Core";
    Team["ROCKET"] = "Team Rocket";
    Team["OKEANOS"] = "Team Okeanos";
    Team["KRONOS"] = "Team Kronos";
    Team["ATLAS"] = "Team Atlas";
    Team["THEIA"] = "Team Theia";
})(Team || (exports.Team = Team = {}));
exports.teamPage = (_a = {},
    _a[Team.WEB_CORE] = 'https://careerpartner.atlassian.net/wiki/spaces/corecomponents/overview',
    _a[Team.ROCKET] = 'https://careerpartner.atlassian.net/wiki/spaces/APP/pages/3337224741/Team+Rocket',
    _a[Team.OKEANOS] = 'https://careerpartner.atlassian.net/wiki/spaces/E/pages/2817819137/Team+Okeanos',
    _a[Team.KRONOS] = 'https://careerpartner.atlassian.net/wiki/spaces/E/pages/2817753613/Team+Kronos',
    _a[Team.ATLAS] = 'https://careerpartner.atlassian.net/wiki/spaces/E/pages/3308159472/Team+Atlas',
    _a[Team.THEIA] = 'https://careerpartner.atlassian.net/wiki/spaces/E/pages/3628335291/Team+Theia',
    _a);
